import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCoffee } from "@fortawesome/free-solid-svg-icons";
import autor from "./Images/author.png";
import Grap from "./Grap";
// import SalesGraph from "./SalesGraph";

import Riwayat from "./Riwaya";
import NewSaleGraph from "./NewSaleGraph";
const Header = () => {
  return (
    <div className="header">
      <div className="heading">
        <div className="head">
          <h1>Penjualan</h1>
        </div>
        <ul className="head-ul">
          <li>
            <i className="fa-solid fa-bell"></i>
          </li>
          <li>
            <img className="author" src={autor} alt="author" /> Admin
            <ul className="log-out">
              <li><i className="list_icon material-icons">logout</i> Log-out</li>
            </ul>
          </li>
        </ul>
      </div>
      <div className="nav">
        <ul className="menu">
          <li className="list active-head">Bimbel Mandiri</li>
          <li className="list">Bimbel Super Intensif</li>
          <li className="list">Tryout SKD</li>
          <li className="list">Test Toefi</li>
          <li className="list"> Sertifikasi</li>
        </ul>
      </div>
      <div className="sale-grap">
        <Grap />
      </div>
      <div className="sale_grap_main_parent">
        {/* <SalesGraph /> */}
        <NewSaleGraph />
        
      </div>

      <div>
        <Riwayat />
      </div>
    </div>
  );
};

export default Header;
